<template>
  <div class="chart-container">
    <div class="chart-title">中心区域项目数量统计</div>
    <div id="barChart" style="width: 100%; height: calc(100% - 30px)"></div>

    <!-- 弹窗组件 -->
    <el-dialog
      :title="`${selectedItem ? selectedItem.name : ''} - 详细数据`"
      :visible.sync="dialogVisible"
      width="90%"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      append-to-body
    >
      <!-- 搜索条件 -->
      <el-form :model="searchForm" ref="searchFormRef" class="search-form" inline>
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item label="小区名称：" prop="communityName">
              <el-input
                v-model="searchForm.communityName"
                placeholder="请输入小区名称"
                clearable
                size="small"
              />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="检验机构：" prop="inspection_organization">
              <el-input
                v-model="searchForm.inspection_organization"
                placeholder="请输入检验机构"
                clearable
                size="small"
              />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="设备代码：" prop="device_code">
              <el-input
                v-model="searchForm.device_code"
                placeholder="请输入设备代码"
                clearable
                size="small"
              />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="年审时间：" prop="audittimes">
              <el-input
                v-model="searchForm.audittimes"
                placeholder="请输入年审时间"
                clearable
                size="small"
              />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="使用登记号：" prop="elevator_sign">
              <el-input
                v-model="searchForm.elevator_sign"
                placeholder="请输入使用登记号"
                clearable
                size="small"
              />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="电梯工号：" prop="elevator_number">
              <el-input
                v-model="searchForm.elevator_number"
                placeholder="请输入电梯工号"
                clearable
                size="small"
              />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="维保单位：" prop="wb_record_unit_name">
              <el-input
                v-model="searchForm.wb_record_unit_name"
                placeholder="请输入维保单位"
                clearable
                size="small"
              />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item>
              <el-button type="primary" @click="handleSearch" icon="el-icon-search"
                >搜索</el-button
              >
              <el-button @click="handleReset" icon="el-icon-refresh">重置</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <!-- 数据表格 -->
      <el-table
        :data="tableData"
        v-loading="tableLoading"
        style="width: 100%;"
        height="400"
        border
      >
        <el-table-column prop="name" label="小区名称" />
        <el-table-column prop="elevator_number" label="电梯工号" width="140" />
        <el-table-column prop="device_code" label="设备代码" width="200" />
        <el-table-column prop="elevator_sign" label="使用登记号" width="140" />
        <el-table-column prop="wb_record_unit_name" label="维保单位" />
        <el-table-column prop="inspection_organization" label="检验机构" width="220" />
        <el-table-column prop="audittimes" label="年审时间" width="80" />
      </el-table>

      <!-- 分页 -->
      <div class="pagination-container" style="text-align: right">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pagination.currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pagination.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pagination.total"
        />
      </div>
    </el-dialog>
  </div>
</template>

<script>
import * as echarts from "echarts";
import { dashboardAPI } from "@/api/dashboard";

export default {
  name: "ProjectStatisticsBarChart",
  props: {
    chartData: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      chartInstance: null,
      dialogVisible: false,
      selectedItem: null,
      tableData: [],
      tableLoading: false,
      searchForm: {
        communityName: "",
        inspection_organization: "",
        device_code: "",
        audittimes: "",
        elevator_sign: "",
        elevator_number: "",
      },
      pagination: {
        currentPage: 1,
        pageSize: 20,
        total: 0,
      },
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart();
      this.updateChart();
    });
  },
  beforeDestroy() {
    if (this.chartInstance) {
      this.chartInstance.dispose();
    }
  },
  watch: {
    chartData: {
      handler() {
        this.updateChart();
      },
      deep: true,
    },
  },
  methods: {
    initChart() {
      const chartDom = document.getElementById("barChart");
      if (chartDom) {
        this.chartInstance = echarts.init(chartDom);

        // 添加点击事件
        this.chartInstance.on("click", (params) => {
          this.handleBarClick(params);
        });
      }
    },
    updateChart() {
      if (!this.chartInstance || !this.chartData.length) return;

      const maxValue = Math.max(...this.chartData.map((item) => item.value), 100);
      const yAxisMax = Math.ceil(maxValue / 20) * 20 + 20;

      const option = {
        tooltip: {
          trigger: "axis",
          axisPointer: { type: "shadow" },
          backgroundColor: "rgba(0, 0, 0, 0.8)",
          borderColor: "#00d4ff",
          textStyle: { color: "#fff" },
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          top: "30px",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          data: this.chartData.map((item) => item.name),
          axisTick: { alignWithLabel: true },
          axisLine: { lineStyle: { color: "#00d4ff" } },
          axisLabel: { color: "#fff", fontSize: 10 },
        },
        yAxis: {
          type: "value",
          name: "数量",
          min: 0,
          max: yAxisMax,
          interval: 20,
          axisLine: { lineStyle: { color: "#00d4ff" } },
          axisLabel: { color: "#fff" },
          splitLine: { lineStyle: { color: "rgba(0, 212, 255, 0.2)" } },
        },
        series: [
          {
            data: this.chartData.map((item) => item.value),
            type: "bar",
            barWidth: "50%",
            label: {
              show: true,
              position: "inside",
              color: "#fff",
              fontSize: 12,
              fontWeight: "bold",
              formatter: "{c}",
            },
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: "#00d4ff" },
                { offset: 1, color: "#0088cc" },
              ]),
              borderRadius: [4, 4, 0, 0],
            },
          },
        ],
      };
      this.chartInstance.setOption(option);
    },

    // 处理柱状图点击事件
    handleBarClick(params) {
      this.selectedItem = this.chartData[params.dataIndex];
      this.dialogVisible = true;
      this.pagination.currentPage = 1;
      this.searchForm = {
        communityName: this.selectedItem.name || "",
        inspection_organization: "",
        device_code: "",
        audittimes: "",
        elevator_sign: "",
        elevator_number: "",
      };
      this.loadTableData();
    },

    // 加载表格数据
    async loadTableData() {
      this.tableLoading = true;
      try {

        const response = await dashboardAPI.getProjectListByRegion(this.searchForm);

        if (response.code === 1) {
          const allData = response.data || [];
          this.pagination.total = allData.length;

          // 前端分页处理
          const start = (this.pagination.currentPage - 1) * this.pagination.pageSize;
          const end = start + this.pagination.pageSize;
          this.tableData = allData.slice(start, end);
        } else {
          this.$message.error(response.msg || "获取数据失败");
        }
      } catch (error) {
        console.error("加载表格数据失败:", error);
        this.$message.error("加载数据失败");
      } finally {
        this.tableLoading = false;
      }
    },

    // 搜索
    handleSearch() {
      this.pagination.currentPage = 1;
      this.loadTableData();
    },

    // 重置搜索条件
    handleReset() {
      this.searchForm = {
        communityName: "",
        inspection_organization: "",
        device_code: "",
        audittimes: "",
        elevator_sign: "",
        elevator_number: "",
      };
      this.pagination.currentPage = 1;
      this.loadTableData();
    },

    // 分页大小改变
    handleSizeChange(val) {
      this.pagination.pageSize = val;
      this.pagination.currentPage = 1;
      this.loadTableData();
    },

    // 当前页改变
    handleCurrentChange(val) {
      this.pagination.currentPage = val;
      this.loadTableData();
    },

    // 获取状态标签类型
    getStatusType(status) {
      const statusMap = {
        正常: "success",
        异常: "danger",
        待检: "warning",
        维修中: "info",
      };
      return statusMap[status] || "info";
    },
  },
};
</script>

<style scoped>
.bar-chart-container {
  background: rgba(10, 25, 41, 0.8);
  border: 1px solid rgba(0, 212, 255, 0.3);
  border-radius: 10px;
  padding: 15px;
  box-sizing: border-box;
  box-shadow: 0 0 20px rgba(0, 212, 255, 0.2);
  flex: 1;
  min-height: 120px;
  position: relative;
  overflow: hidden;
  box-sizing: border-box;
}

.bar-chart-container::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 2px;
  background: linear-gradient(90deg, transparent, rgba(0, 212, 255, 0.8), transparent);
}

/* 图表标题样式 - 与电梯维保单位模块保持一致 */
.chart-title {
  font-size: 16px;
  margin: 10px 0;
  color: #00d4ff;
  text-align: center;
  font-weight: bold;
}

/* 搜索表单样式 - 已移除，使用默认样式 */

/* 分页容器样式 */
.pagination-container {
  padding: 10px 0;
}

/* 表格样式优化 - 已移除，使用默认样式 */

/* 弹窗样式优化 - 仅保留标题颜色以保持一致性 */
.el-dialog__title {
  color: #00d4ff !important;
}
</style>
